import { KeyboardArrowDown } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { MuiMultiFieldWithFocus } from '../../config/MaterialUIConstants';
import useGlobalStore from '../../store/useGlobalStore';
import TermsAndWarrantySelect from '../TermsAndWarranty/TermsAndWarrantySelect';
import PaymentDetailSvg from '../../utility/Svg/PaymentDetailSvg';

const AdditionalDetailsAccrodian = ({
    type = null,
    setInvoiceDataInStore,
    invoiceDataInStore,
    index,
    accordianExpanded,
    handleAccordianToggle,
    setValue,
    errors,
    control,
    termsOptions = [],
    onNewTerms,
    onEditTerms,
    hidePoCustomer = false,
    hideInternalShopMemo = true,
    /** Work orders carry an Authorization block instead of terms & warranty (spec §4.5). */
    hideTerms = false,
}) => {
    const { isDirty, markSaved } = useGlobalStore();
    return (
        <Grid item xs={12}>
            <Accordion
                expanded={accordianExpanded.includes(index)}
                style={{
                    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.10)',
                    borderRadius: '8px',
                    background: '#fff',
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <IconButton style={{ background: '#334FA9', padding: '0', width: '30px', height: '30px' }}>
                            <KeyboardArrowDown sx={{ color: '#fff', fontSize: '26px' }} />
                        </IconButton>
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordianSummaryPadding"
                    style={{
                        minHeight: '80px',
                    }}
                    onClick={() => {
                        handleAccordianToggle(index);
                    }}
                >
                    <div className="accordianTitleWrapper">
                        <PaymentDetailSvg /> <Typography className="accordianTitle">Additional Details</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails className="accordianDetailsWrapper">
                    <Grid container>
                        <Grid container item spacing={3}>
                            {!hidePoCustomer && (
                                <Grid item xs={12}>
                                    <Typography className="formLabelTitle" mb={1}>
                                        Customer PO #
                                    </Typography>
                                    <Controller
                                        name="customerPO"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                onChange={(event) => {
                                                    field.onChange(event.target.value);
                                                    if (type === 'invoice') {
                                                        if (!event.target.value && invoiceDataInStore?.customerPO) {
                                                            const { customerPO, ...rest } = invoiceDataInStore;
                                                            setInvoiceDataInStore(rest);
                                                        } else {
                                                            setInvoiceDataInStore({
                                                                ...invoiceDataInStore,
                                                                customerPO: event.target.value,
                                                            });
                                                        }
                                                    }
                                                }}
                                                multiline
                                                minRows={1}
                                                maxRows={5}
                                                fullWidth
                                                error={!!errors.note}
                                                helperText={errors.note ? errors.note.message : ''}
                                                sx={{
                                                    minHeight: '50px',
                                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                    borderRadius: '8px',
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                        padding: '12px 12px 12px 12px',
                                                        minHeight: '50px',
                                                    },
                                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                        borderRadius: '8px',
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            )}

                            {!hideTerms && (
                                <TermsAndWarrantySelect
                                    control={control}
                                    errors={errors}
                                    options={termsOptions}
                                    onNew={onNewTerms}
                                    onEdit={onEditTerms}
                                    setValue={setValue}
                                    type={type}
                                    invoiceDataInStore={invoiceDataInStore}
                                    setInvoiceDataInStore={setInvoiceDataInStore}
                                />
                            )}

                            <Grid item xs={12}>
                                <Typography variant="body1" sx={{ mb: 1, fontWeight: 500, color: '#212121' }}>
                                    Shop Internal Memo
                                </Typography>
                                <Controller
                                    name="note"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            multiline
                                            rows={2}
                                            fullWidth
                                            sx={MuiMultiFieldWithFocus}
                                            onChange={(e) => {
                                                field.onChange(e.target.value);
                                                if (!isDirty) {
                                                    markSaved();
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default AdditionalDetailsAccrodian;
